<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="visable"
			@handleClose="convclose"
			dialogWidth="600px"
		>
			<dialogtitle
				slot="title"
				title="转为垃圾询盘"
				subtitle="此条线索将被转为垃圾询盘，完成后您可以在垃圾线索池里进行再次查看"
				:subStyle="{ display: 'block', fontSize: '12px', marginLeft: 0 }"
			></dialogtitle>
			<div class="convert-form-content convert-garbage">
				<span v-if="getDetailsData.email" class="convert-adress">{{ getDetailsData.email }}</span>
				<span v-else class="no-convert-adress">无询盘地址</span>
				<span>
					<el-checkbox v-model="conver_checked" :disabled="!getDetailsData.email"
						>添加过滤地址</el-checkbox
					>
				</span>
			</div>
			<!-- 说明文本 -->
			<div class="convert-remarks">
				<span
					>您同时可以将此询盘邮箱地址加入过滤名单，
					此地址再次发送线索时，将会自动归为疑似垃圾询盘，</span
				>
				详细地址名单可进入
				<span class="font-bold">设置-系统设置-垃圾询盘过滤</span>
				中进行查看编辑
			</div>
			<dialogfooter
				slot="footer"
				:visible.sync="visable"
				@onclose="convclose"
				@confirm="convsubmit"
			></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogtitle from '@/components/crm/crm-dialog-title.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import clueSer from '@/client/services/clue/clueSer.js';
import { mapGetters } from 'vuex';
export default {
	props: {
		getDetailsData: {
			type: Object,
		},
		conv_visible: {
			type: Boolean,
		},
	},
	data() {
		return {
			conver_checked: false,
			visable: false,
		};
	},
	watch: {
		conv_visible: {
			handler() {
				this.visable = this.conv_visible;
			},
		},
	},
	computed: {
		...mapGetters(['chatListData', 'allChatList', 'userInfo']),
	},
	methods: {
		convclose() {
			this.conver_checked = false;
			this.visable = false;
			this.$emit('update:conv_visible', false);
		},
		async convsubmit() {
			//ruleType (0:信任;1:不信任;)  mateType 1:邮件地址;2:域名后缀;)
			let mateType = this.conver_checked ? 1 : undefined;
			let param = {
				salesleadId: this.getDetailsData.summaryId, //477918524086419456,
				inquiryConvertDto: {
					ruleType: 1,
					mateType,
				},
			};
			if (this.getDetailsData.summaryId) {
				// eslint-disable-next-line no-unused-vars
				let res = await clueSer.inquiryConvert(param);
				if (res) {
					this.convclose();
					//对聊天列表数据进行处理，移入垃圾池不出现这条数据，聊天界面回为初始状态，侧边抽屉不显示
					// let flag = this.chatListData.findIndex(e => e.id == this.getDetailsData.summaryId);
					// this.chatListData.splice(flag, 1);
					// this.$store.dispatch('setChatListData', this.chatListData);
					let item;
					if (this.$route.name == 'allChat') {
						item = this.allChatList.find(e => {
							if (e.id == this.getDetailsData.summaryId) {
								return e;
							}
						});
					} else {
						item = this.chatListData.find(e => {
							if (e.id == this.getDetailsData.summaryId) {
								return e;
							}
						});
					}

					// this.chatListData.splice(flag, 1);
					// this.$store.dispatch('setChatListData', this.chatListData);
					// this.$store.dispatch('setChatNoData', false);
					this.$router.push({
						name: this.$route.name,
						query: {
							followupName: this.userInfo.accountId,
							type: item.type,
							id: item.id,
							tableId: item.tableId,
						},
					});
					this.$emit('change', 1);
					this.$message.success('设置成功');
					this.$emit('close');
				}
			}
		},
	},
	components: { dialogtitle, dialogfooter, formDialog },
};
</script>
<style lang="scss" scoped>
.convert-form-content {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0 40px;
	.convert-form-item {
		padding: 10px 0;
		display: flex;
		align-items: center;
	}
	.convert-adress {
		margin-right: 40px;
		font-size: 18px;
		font-weight: 500;
		color: #333;
		width: 200px;
		text-align: left;
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.no-convert-adress {
		margin-right: 40px;
		font-size: 14px;
		font-weight: 500;
		color: #c0c4cc;
		width: 200px;
		text-align: left;
		display: inline-block;
	}
}
.convert-remarks {
	color: #999;
	font-size: 14px;
	font-weight: 400;
	line-height: 23px;
	margin-bottom: 20px;
	.font-bold {
		color: #333;
		font-weight: bold;
	}
}
</style>
